import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { space } from "@smartsheet/design-tokens";
import { sizes } from "../../../constants/spacing";
import { getButtonLoadingStyles } from "../styled/getButtonLoadingStyles";
var ursaMargin = {
  xsmall: space.space05,
  small: space.space10,
  medium: space.space20,
  large: space.space30
};
var singleIconMargin = {
  xsmall: "2px",
  small: "2px",
  medium: space.space10,
  large: space.space20
};
var insideMargin = {
  xsmall: 1,
  small: 1,
  medium: 3,
  large: 3
};
var iconsOnlyInsideMargin = {
  xsmall: -1,
  small: 1,
  medium: 2,
  large: 2
};
var getIconWrapperMargin = function getIconWrapperMargin(_ref) {
  var size = _ref.size,
    appearance = _ref.appearance,
    iconLocation = _ref.iconLocation,
    hasLeftIcon = _ref.hasLeftIcon,
    hasOnlyIcons = _ref.hasOnlyIcons,
    hasRightIcon = _ref.hasRightIcon;
  var isTwoIconsOnly = hasLeftIcon && hasRightIcon && hasOnlyIcons;
  var isSingleIcon = hasOnlyIcons && (hasLeftIcon && !hasRightIcon || !hasLeftIcon && hasRightIcon);
  if (isSingleIcon) {
    return "calc(".concat(singleIconMargin[size], " - 1px)");
  } else {
    switch (appearance) {
      // For Lodestar buttons.
      case "borderless":
      case "primary":
      case "secondary":
      case "destructive":
      case "destructive-tertiary":
      case "secondary-destructive":
      case "share":
        return "0 ".concat((size === "large" ? sizes.xSmall : sizes.xxSmall) - 1, "px");
      // For Ursa buttons.
      case "primary-filled":
      case "primary-empty":
      case "secondary-filled":
      case "secondary-outlined":
      case "secondary-empty":
      case "canvas-filled":
      case "canvas-empty":
      case "destructive-filled":
      case "destructive-empty":
        if (iconLocation === "before") {
          return isTwoIconsOnly && size === "small" ? // account for size small outer spacing being different than all other situations
          "0 1px" : "0 ".concat(insideMargin[size], "px 0 calc(").concat(ursaMargin[size], " - 1px)");
        } else {
          return isTwoIconsOnly && size === "small" ? // account for size small outer spacing being different than all other situations
          "0 1px" : "0 calc(".concat(ursaMargin[size], " - 1px) 0 ").concat(insideMargin[size], "px");
        }
    }
  }
};
export var IconWrapper = styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    align-self: center;\n    display: flex;\n    flex-shrink: 0;\n    line-height: 0;\n    font-size: 0;\n    user-select: none;\n    margin: ", ";\n\n    // inner margin overrides for double icons with no text\n    margin-left: ", ";\n    margin-right: ", ";\n\n    ", "\n"])), function (_ref2) {
  var size = _ref2.size,
    appearance = _ref2.appearance,
    iconLocation = _ref2.iconLocation,
    hasLeftIcon = _ref2.hasLeftIcon,
    hasOnlyIcons = _ref2.hasOnlyIcons,
    hasRightIcon = _ref2.hasRightIcon;
  return getIconWrapperMargin({
    size: size,
    appearance: appearance,
    iconLocation: iconLocation,
    hasLeftIcon: hasLeftIcon,
    hasOnlyIcons: hasOnlyIcons,
    hasRightIcon: hasRightIcon
  });
}, function (_ref3) {
  var hasLeftIcon = _ref3.hasLeftIcon,
    hasOnlyIcons = _ref3.hasOnlyIcons,
    iconLocation = _ref3.iconLocation,
    size = _ref3.size;
  return hasLeftIcon && hasOnlyIcons && iconLocation === "after" ? "".concat(iconsOnlyInsideMargin[size], "px") : null;
}, function (_ref4) {
  var hasRightIcon = _ref4.hasRightIcon,
    hasOnlyIcons = _ref4.hasOnlyIcons,
    iconLocation = _ref4.iconLocation,
    size = _ref4.size;
  return hasRightIcon && hasOnlyIcons && iconLocation === "before" ? "".concat(iconsOnlyInsideMargin[size], "px") : null;
}, function (_ref5) {
  var isLoading = _ref5.isLoading;
  return getButtonLoadingStyles(isLoading);
});
//# sourceMappingURL=IconWrapper.js.map